import { Component } from '@angular/core';

@Component({
    selector: 'ez-unsub-notifications',
    template: require('./unsub-notifications.component.html'),
    styles: [require('./unsub-notifications.component.less')]
})
export class UnsubNotificationsComponent  {
    public classes: string = 'stopNotifications';
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/feedback/unsub-notifications/unsub-notifications.component.ts